import React from "react";
import { cn } from "@/lib/utils";

export const GlassCard = ({ className, children, ...props }) => (
  <div
    className={cn(
      "glass rounded-xl overflow-hidden transition-colors hover:bg-white/[0.05]",
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export default GlassCard;
